import { render, staticRenderFns } from "./addprocedures.vue?vue&type=template&id=62025eb3&scoped=true&"
import script from "./addprocedures.vue?vue&type=script&lang=js&"
export * from "./addprocedures.vue?vue&type=script&lang=js&"
import style0 from "./addprocedures.vue?vue&type=style&index=0&id=62025eb3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62025eb3",
  null
  
)

export default component.exports